import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import dependencies from 'contest/apps/design-details/di';

import CommentForm from './comment-form';
import CommentList from '@99designs/ddo/components/CommentList';
import { resetSelectedComment, createDesignComment } from '@99designs/ddo/actions/design-comments';

export default class CommentPane extends React.Component {
    constructor() {
        super();

        this.state = {
            isVisible: false,
            timeLastCreated: 0,
        };

        this.handleCommentFormClick = this.handleCommentFormClick.bind(this);
        this.handleCreateComment = this.handleCreateComment.bind(this);
    }

    componentDidMount() {
        this.setState({ isVisible: true });
    }

    commentPaneFooter() {
        if (this.props.hasCommentForm) {
            return (
                <div className="comment-pane__footer">
                    <CommentForm
                        key={this.state.timeLastCreated}
                        canScrollIntoViewOnMount={this.props.canAutoScroll}
                        scrollingContainer={document.querySelector('#fullscreenSidebar')}
                        onClick={this.handleCommentFormClick}
                        onKeyDown={this.props.onCommentKeyDown}
                        onKeyUp={this.props.onCommentKeyUp}
                        hasUserCommented={this.hasUserCommented()}
                        onSubmit={this.handleCreateComment}
                        design={this.props.design}
                    />
                </div>
            );
        }
    }

    render() {
        var classes = classNames({
            'comment-pane': true,
            'comment-pane--hidden': !this.state.isVisible && this.props.hasTransition,
        });

        return (
            <div className={classes} data-comment-pane onClick={this.handlePanelClick}>
                <div className="comment-pane__body">
                    <CommentList
                        design={this.props.design}
                        comments={this.props.comments}
                        selectedComment={this.props.selectedComment}
                        selectedCommentStatus={this.props.selectedCommentStatus}
                        canShowCommentEditing={this.props.canShowCommentEditing}
                    />
                </div>
                {this.commentPaneFooter()}
            </div>
        );
    }

    hasUserCommented() {
        return Boolean(
            this.props.comments.filter(c => c.creator.userId === this.props.activeUser.userId)
                .length
        );
    }

    handleCreateComment(content) {
        const comment = dependencies.models.designComment.create({
            message: content,
            creator: this.props.activeUser,
        });

        this.context.executeAction(createDesignComment, {
            comment,
            design: this.props.design,
            csrfToken: this.context.csrfToken,
        });

        // updating the key of the CommentForm element effectively clear the form
        this.setState({
            timeLastCreated: new Date().getTime(),
        });
    }

    handleCommentFormClick(e) {
        if (this.props.selectedComment) {
            this.context.executeAction(resetSelectedComment, {});
        }
        e.stopPropagation();
    }

    handlePanelClick(e) {
        e.stopPropagation();
    }
}

CommentPane.contextTypes = {
    getStore: PropTypes.func.isRequired,
    executeAction: PropTypes.func.isRequired,
    csrfToken: PropTypes.string,
};

CommentPane.propTypes = {
    design: PropTypes.object.isRequired,
    activeUser: PropTypes.object,
    canAutoScroll: PropTypes.bool,
    canShowCommentEditing: PropTypes.bool,
    comments: PropTypes.array,
    hasCommentForm: PropTypes.bool,
    hasTransition: PropTypes.bool,
    selectedComment: PropTypes.object,
    selectedCommentStatus: PropTypes.oneOf(['creating', 'editing', 'saving', 'deleting', 'error']),
    onCommentKeyDown: PropTypes.func,
    onCommentKeyUp: PropTypes.func,
    autoFocusCommentForm: PropTypes.bool,
};

CommentPane.defaultProps = {
    canAutoScroll: false,
    canShowCommentEditing: false,
    comments: [],
    hasCommentForm: false,
    hasTransition: true,
    onCommentKeyDown() {},
    onCommentKeyUp() {},
    autoFocusCommentForm: false,
};



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/design-details/components/comment-pane.jsx